import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { ListProject } from "./ListProject";


const Output = [
  {
    key: "1",
    地域No: "01",
    地域名: "【特定】東京都心・臨海地域",
    種類: "bbb",
    整理No: "ccc",
    プロジェクト名: "ddd",
  },
  {
    key: "2",
    地域No: "01",
    地域名: "eee",
    種類: "bbb",
    整理No: "ccc",
    プロジェクト名: "ddd",
  },
];

function ParamsSet() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const 地域名 = searchParams.get("地域名");
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState(地域名);
  const [initialRender, setInitialRender] = useState(true);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    const item = ListProject.find(item => item['地域名'] === selectedRegion);
    setSelectedItem(item);
    if (selectedRegion) {
      const params = new URLSearchParams(searchParams.toString());
      params.set('地域名', selectedRegion);
      window.history.replaceState(null, null, `${location.pathname}?${params.toString()}`);
    }

  }, [selectedRegion, initialRender, searchParams, location.pathname]);


  const handleClick = (item) => {
    setSelectedRegion(item);
    setModalVisible(false);
  };

 const uniqueRegions = [...new Set(ListProject.map(item => item.地域名))];

  return (
    <div>
      <main className="flex md:my-3 md:mx-2 pointer-events-auto">
        <div
          className="md:rounded-xl p-1 md:py-1 bg-black bg-opacity-80 text-white"
          x-data="app"
        >
          <div className="block cursor-pointer select-none md:rounded-xl px-0 md:px-2 py-0 md:py-2 text-3xl md:text-3xl lg:text-3xl ">

            {selectedItem && (
              <div onClick={() => setModalVisible(true)}>
                {selectedItem.地域名}
              </div>
            )}
            {modalVisible && (
              <div className="modal">
                <ul>
                {uniqueRegions.map((region, index) => (
  <li key={index} onClick={() => handleClick(region)}>
    {region}
  </li>
))}
                  {/* {ListProject.map((item, index) => (
                    <li key={index} onClick={() => handleClick(item)}>
                      {item.地域名}
                    </li>
                  ))} */}
                </ul>
              </div>
            )}



          </div>
        </div>
      </main>
    </div>
  );
}

export default ParamsSet;
